export const reactionEmojis = ['❤️', '💯', '🐍', '😂', '😳', '🤔'];